import React, { PureComponent } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import { ErrorAlert, SpinnerAlert } from 'components/alerts';
import { ButtonPrimary } from 'components/buttons';
import './style.scss';

class ActivationStatus extends PureComponent {
    state = {};

    constructor(props) {
        super(props);
    }

    renderButton() {
        const { handleActivationButton } = this.props;
        if (!handleActivationButton) return null;
        return (
            <ButtonPrimary classes={[]} onClick={handleActivationButton}>
                <Literal literal="action_download_retry" />
            </ButtonPrimary>
        );
    }

    renderAlert() {
        const { type, title, text, icon } = this.props;
        switch (type) {
            case 'spinner':
                return (
                    <SpinnerAlert
                        title={<Literal literal={title} />}
                        text={<Literal literal={text} />}
                        shrink={true}
                    />
                );
            case 'error':
                return (
                    <ErrorAlert
                        title={<Literal literal={title} />}
                        text={<Literal literal={text} />}
                        iconDisplay={icon}
                        shrink={true}
                    />
                );
            default:
                return null;
        }
    }

    render() {
        return (
            <div className="activation-status">
                {this.renderAlert()}
                {this.renderButton()}
            </div>
        );
    }
}

export default ActivationStatus;
